import { Cancel, CheckCircle } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React from "react";

/**
 * Check Document Button Component to check a document
 * @param documentType - the type of the document
 * @param checked - boolean if the document is checked
 * @param changeProjectBillingDocumentStatus - function to change the status of a project billing document
 * @returns Check Document Button Component
 */
const CheckDocumentButton = ({
  documentType,
  checked,
  changeProjectBillingDocumentStatus,
}: {
  documentType:
    | "APatEV"
    | "APHold"
    | "evaluationAtEV"
    | "DLatEV"
    | "offerInAlfresco"
    | "deviationFromStandard"
    | "consultingContractProvided"
    | "teamContractProvided"
    | "qmApproval"
    | "paymentDelay"
    | "moneyReceived";
  checked: boolean;
  changeProjectBillingDocumentStatus: (
    documentType:
      | "APatEV"
      | "APHold"
      | "evaluationAtEV"
      | "DLatEV"
      | "offerInAlfresco"
      | "deviationFromStandard"
      | "consultingContractProvided"
      | "teamContractProvided"
      | "qmApproval"
      | "paymentDelay"
      | "moneyReceived",
    completed: boolean
  ) => void;
}) => {
  return (
    <Button
      sx={{ flex: 1 }}
      variant="contained"
      color={"secondary"}
      size="small"
      onClick={() => {
        changeProjectBillingDocumentStatus(documentType, !checked);
      }}
    >
      {checked ? (
        <Cancel color="error" sx={{ marginRight: 2 }} fontSize="small" />
      ) : (
        <CheckCircle color="success" sx={{ marginRight: 2 }} fontSize="small" />
      )}
      <Typography fontSize={10}>{checked ? "Rückgängig" : "Markieren"}</Typography>
    </Button>
  );
};

export default CheckDocumentButton;
